import { Box, Grid, Link, Paper } from "@mui/material"
import DownloadOnTheAppStore from "../../assets/apple/download-on-the-app-store/black.svg"
import BackgroundLogo from "../../assets/elm/background.jpg"
import NarvanLogo from "../../assets/narvan/Narvan-logos-white-02_1.png"
import GetItOnGooglePlay from "../../assets/google/get-it-on-google-play/en_badge_web_generic.svg"
import { Link as RouterLink } from "react-router-dom"

function Home() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      width={"100%"}
      style={{
        backgroundImage: `url(${BackgroundLogo})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
      }}
    >
      <Paper elevation={3} sx={{ borderRadius: 5, width: 400, paddingX: 2 }}>
        <Grid container textAlign={"center"} paddingY={4}>
          <Grid item xs={12}>
            <img
              style={{ height: "80px" }}
              src={NarvanLogo}
              alt="Narvan Houseplants Logo"
            />
          </Grid>
          <Grid mb={2} item xs={12}>
            <p style={{ fontSize: 13 }}>
              Search <strong>Narvan Houseplants</strong> in the Google Play or
              App Store
            </p>
          </Grid>
          <Grid alignItems={"center"} item xs={6}>
            <a href="https://apps.apple.com/gb/app/narvan/id6470710238">
              <img
                style={{ height: "40px" }}
                src={DownloadOnTheAppStore}
                alt="Download on the App Store"
              />
            </a>
          </Grid>
          <Grid item alignItems={"center"} xs={6}>
            <a href="https://play.google.com/store/apps/details?id=uk.co.narvan.app">
              <img
                style={{ height: "40px" }}
                src={GetItOnGooglePlay}
                alt="Get it on Google Play"
              />
            </a>
          </Grid>
          <Grid mb={2} item xs={12}>
            <p style={{ fontSize: 13 }}>
              <Link component={RouterLink} to="/terms">
                Terms
              </Link>{" "}
              &nbsp;
              <Link component={RouterLink} to="/privacy">
                Privacy Policy
              </Link>
            </p>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  )
}

export default Home
